/**
 *  @class
 *  @function Listcollections
 */
if (!customElements.get('list-collections')) {
  class Listcollections extends HTMLElement {
    constructor() {
      super();
      this.dotsContainer = null;
      this.currentSlide = 0;
      this.totalSlides = 0;
      this.flickityInstance = null;
    }
    
    connectedCallback() {
      this.setAnimations();
      
      // Warte bis Flickity initialisiert ist
      setTimeout(() => {
        this.initCustomDots();
      }, 300);

      if (Shopify.designMode) {
        this.addEventListener('shopify:section:load', (event) => {
          this.setAnimations();
          setTimeout(() => {
            this.initCustomDots();
          }, 300);

          setTimeout(() => {
            ScrollTrigger.refresh();
          }, 100);
        });
      }
    }
    
    initCustomDots() {
      const carousel = this.querySelector('slide-show.collection-grid--carousel');
      
      if (carousel && carousel.classList.contains('flickity-enabled')) {
        const showDots = carousel.dataset.pageDots === 'true';
        
        if (showDots) {
          // Entferne existing dots (falls vorhanden)
          const existingDots = this.querySelector('.flickity-page-dots');
          if (existingDots) {
            existingDots.remove();
          }
          
          // Hole Flickity-Instanz
          this.flickityInstance = Flickity.data(carousel);
          
          if (this.flickityInstance) {
            // Erstelle neue Dots basierend auf Flickity-Slides
            this.createFlickityDots(carousel);
            this.bindFlickityEvents(carousel);
          }
        }
      }
    }
    
    createFlickityDots(carousel) {
      if (!this.flickityInstance) return;
      
      this.totalSlides = this.flickityInstance.slides.length;
      
      if (this.totalSlides <= 1) return;
      
      // Erstelle Dots Container
      this.dotsContainer = document.createElement('div');
      this.dotsContainer.className = 'flickity-page-dots';
      
      // Erstelle einzelne Dots
      for (let i = 0; i < this.totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = `dot ${i === 0 ? 'is-selected' : ''}`;
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          this.goToSlide(i);
        });
        this.dotsContainer.appendChild(dot);
      }
      
      // Füge Dots nach dem Carousel hinzu
      carousel.parentNode.appendChild(this.dotsContainer);
    }
    
    bindFlickityEvents(carousel) {
      if (!this.flickityInstance) return;
      
      // Lausche auf Flickity's select Event
      this.flickityInstance.on('select', () => {
        const currentIndex = this.flickityInstance.selectedIndex;
        this.updateDots(currentIndex);
      });
      
      // Lausche auf change Event
      this.flickityInstance.on('change', () => {
        const currentIndex = this.flickityInstance.selectedIndex;
        this.updateDots(currentIndex);
      });
      
      // Initial dot update
      this.updateDots(this.flickityInstance.selectedIndex);
    }
    
    goToSlide(slideIndex) {
      if (this.flickityInstance) {
        this.flickityInstance.select(slideIndex);
      }
    }
    
    updateDots(activeIndex) {
      if (!this.dotsContainer) return;
      
      const dots = this.dotsContainer.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-selected', index === activeIndex);
      });
      
      this.currentSlide = activeIndex;
    }
    
    setAnimations() {
      if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.batch(this.querySelectorAll('.collection-card--image-image'), {
          start: "top 90%",
          onEnter: (elements, triggers) => {
            gsap.fromTo(elements, 
              { scale: 1.15 }, 
              { 
                scale: 1, 
                opacity: 1, 
                stagger: 0.15, 
                ease: window.theme?.settings?.animation_easing || 'power2.out', 
                clearProps: 'transform' 
              }
            );
          },
        });
      }
    }
  }
  customElements.define('list-collections', Listcollections);
}